/*
 From https://gist.github.com/jarsbe/af55f3705add9d9ec34fd0cb25ef2f67
 Referenced by https://github.com/draft-js-plugins/draft-js-plugins/issues/302
 */
//import {EditorState, Modifier, Entity, SelectionState} from 'draft-js'
import linkifyIt from 'linkify-it'
import tlds from 'tlds'

const linkify = linkifyIt()

linkify.tlds(tlds)
    .add('mailto:', null)              // Disable `ftp:` protocol
    .set({ fuzzyEmail: false });

export const findFirstLinkInText = (text) => {
    // First try to find complete URLs with protocol (http/https) using regex
    // This catches URLs immediately without needing a space after them
    const urlRegex = /https?:\/\/[^\s<]+[^\s<.,;!?'")\]]/gi
    const matches = text.match(urlRegex)
    if (matches && matches.length > 0) {
        return matches[0]
    }

    // Fall back to linkify-it for fuzzy matching (www.example.com without protocol)
    const links = linkify.match(text)
    if (typeof links !== 'undefined' && links !== null)
        return links[0].url
    else
        return null
}
